import { getCoverageLinesText } from '@common/utils';
import { useNavigate } from 'react-router-dom-latest';
import { IconButton, Stack, Typography } from '@common-components';
import { ArrowBackIosNew } from '@icons';
import { messages } from 'i18n';
import { PartialSubmission } from 'types';
import { getDotSeparated, getTimezoneLessDisplayDate } from 'utils';
import { BROKER_ROUTES } from 'broker/broker-routes';

interface HeaderProps {
  submission: PartialSubmission;
}

export default function Header({ submission }: HeaderProps) {
  const navigate = useNavigate();

  const coverageLines = getCoverageLinesText(submission.coverageLines);
  const dueDate = submission.dueDate
    ? messages.submissionWorkspace.header.details.effectiveDate(getTimezoneLessDisplayDate(submission.dueDate))
    : '';

  return (
    <Stack bgcolor="common.white" px={3} width={1} direction="row" alignItems="center" gap={2} py={1.5}>
      <IconButton
        icon={ArrowBackIosNew}
        size="small"
        color="secondary"
        variant="text"
        onClick={() => navigate(`/${BROKER_ROUTES.CARRIER_SUBMISSION_QUEUE}`)}
      />
      <Stack flex={1} minWidth={0}>
        <Typography variant="h4" noWrap>
          {submission.insuredName || 'Submission Details'}
        </Typography>
        {coverageLines && (
          <Typography variant="body2" color="typography.nonEssential" noWrap>
            {getDotSeparated([coverageLines, dueDate])}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
